"use client";
import { useAppSelector } from "@/hooks/useAppSelector";
import { trackEvent } from "@/lib/gtag";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const HeaderWhatsApp: React.FC = () => {
  const phNumber = "919429693000";

  const { phoneNumber } = useAppSelector((state) => state.auth);

  const openWhatsAppChat = () => {
    const whatsappURL = `https://wa.me/${phNumber}`;
    window.open(whatsappURL, "_blank");
    trackEvent({
      action: "whatsapp_click",
      category: "engagement",
      label: "WhatsApp Support Click",
      value: Number(phoneNumber),
    });
  };

  return (
    <button
      onClick={openWhatsAppChat}
      className="bg-green text-white p-2 rounded-full hover:bg-green-600 transition-all"
      aria-label="Contact on WhatsApp"
    >
      <FaWhatsapp className="text-xl" />
    </button>
  );
};

export default HeaderWhatsApp;
